// @ts-nocheck

class ProductDetailsTabs {
  constructor() {
    this.root = document.querySelector('[data-pdp-details]');
    if (!this.root) return;

    this.tabs = this.root.querySelectorAll('[data-pdp-tab]');
    this.panels = this.root.querySelectorAll('[data-pdp-panel]');
    if (!this.tabs.length || !this.panels.length) return;

    this.setupEvents();
  }

  setupEvents() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.getAttribute('data-pdp-tab')));
    });
  }

  activate(name) {
    this.tabs.forEach((tab) => {
      const isActive = tab.getAttribute('data-pdp-tab') === name;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.getAttribute('data-pdp-panel') !== name;
    });
  }
}

new ProductDetailsTabs();
